import { useAuthStore } from '../store/auth';

export function useRole() {
  const groups = useAuthStore((s) => s.user?.groups ?? []);
  return {
    isAdmin: groups.includes('admin'),
    isEditor: groups.includes('editor'),
    isViewer: groups.includes('viewer'),
    canEdit: groups.includes('admin') || groups.includes('editor'),
    canManageUsers: groups.includes('admin'),
  };
}
